import React from 'react';
import useStyles from './styles';
import classNames from 'classnames';
import { CircularProgress } from '@material-ui/core';

export default function Textbox(props) {
  const classes = useStyles();

  return (
    <div
      className={classNames(
        classes.textbox_container,
        props.containerClassName && props.containerClassName,
      )}
    >
      {props.label && (
        <label
          className={classNames(
            classes.input_label,
            props.labelClassName && props.labelClassName,
          )}
          htmlFor={props.label}
        >
          {props.label}
        </label>
      )}
      {props.leftIcon && (
        <img
          className={classNames(
            classes.left_icon,
            props.leftIconClassName && props.leftIconClassName,
          )}
          src={props.leftIcon}
          alt=''
          onClick={props.onLeftIcon && props.onLeftIcon}
        />
      )}
      {props.multiline ? (
        <textarea
          className={classNames(
            classes.textbox,
            props.className && props.className,
          )}
          rows={props.rows ? props.rows : '7'}
          // cols='70'
          value={props.value}
          onChange={props.onChange}
          placeholder={props.placeholder}
          disabled={props.disabled}
          autoFocus={props.autoFocus}
        />
      ) : (
        <input
          type={props.type ? props.type : 'text'}
          className={classNames(
            classes.textbox,
            props.className && props.className,
          )}
          onChange={props.onChange}
          onClick={props.onClick}
          name={props.name}
          value={props.value}
          placeholder={props.placeholder}
          disabled={props.disabled}
          ref={props.inputRef && props.inputRef}
          readOnly={props.readOnly}
          onKeyDown={props.onKeyDown}
          onBlur={props.onBlur}
          min={props.min}
          maxlength={props.maxlength}
        />
      )}
      {props.error && (
        <p
          className={classNames(
            classes.input_error,
            props.errorClassName && props.errorClassName,
          )}
        >
          {props.helperText}
        </p>
      )}
      {props.rightIcon &&
        (props.rightIconLoader ? (
          <CircularProgress size={20} className={classes.right_icon} />
        ) : (
          <img
            className={classNames(
              classes.right_icon,
              props.rightIconClassName && props.rightIconClassName,
            )}
            src={props.rightIcon}
            alt=''
            onClick={props.onRightIcon && props.onRightIcon}
          />
        ))}
    </div>
  );
}
